import { Component, TemplateRef, OnInit } from '@angular/core';
import { UserPage } from '../models/login';
import { ApiService } from '../Services/api-service';
import { UserMasterResponse, User, MyExcelData } from '../models/user';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/ngx-bootstrap-pagination';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../excel.service'
import * as moment from 'moment';
import { States, StateResponse } from '../models/State';
import { CityResponse, City } from '../models/city';
import * as XLSX from 'xlsx';
import { DealerMasterResponse } from '../models/dealer';
//import { Dealer, DealerMasterResponse } from '../models/dealer';
import { NgForm } from '@angular/forms';
import { ScanReport } from '../models/report';
type AOA = any[][];


interface Contractor {
  ID: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Mobile: string;
  ScanDate: string;
  UsrGroup: number;
  TotalEarnedPoints: number;
  TotalPendingPoints: number;
  RedeemedPoints: number;
  CancelPoints: number;
  AvailablePoints: number;
  TotalCount: number;
}

// interface Dealer {
//   ContractorPoints: any;
//   DealerUsrGroup: any;
//   ContractorUsrGroup: number; // Added
//   ContractorFirstName: string; // Added
//   ContractorEmail: string; // Added
//   ContractorMobile: string; // Added
//   ContractorId: any;
//   DealerId: number;
//   DealerUsr: number;
//   DealerFirstName: string;
//   DealerEmail: string;
//   DealerMobile: string;
//   Contractors: Contractor[];
// }



@Component({
  selector: 'app-contractorptreport',
  templateUrl: './contractorptreport.component.html',
  styleUrls: ['./contractorptreport.component.css']
})



export class ContractorptreportComponent implements OnInit {
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];

  groupedDealers: any[] = [];
  reportExcelPassbook: any[] = [];
  pagesUser: UserPage = new UserPage();
  // users: Dealer[] = [];
  //formval: Dealer = new Dealer();
  show: boolean = false;
  modalhead: string = "Upload Dealer Details";
  dnm: boolean = false;
  result: string = "0"
  totaldata: number;
  activate: string = "done"
  numberedit: string = "";
  data1: any = [];
  data: AOA = [];
  templateDealer: MyExcelData[] = [];
  modalRef: BsModalRef;
  errorList: User[] = [];
  modalRef2: BsModalRef;
  modalRef3: BsModalRef;
  modalRef4: BsModalRef;
  states: States[] = [];
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isEdit: boolean = true;
  cities: City[] = [];
  SuccessCount: string = "0"
  ErrorCount: string = "0";
  currentPage: number;
  // dealerlist: Dealer[] = [];
  buttonText: string = "Save";
  DeleteId: number;
  IsActive: boolean;
  DealerId: number;
  scanreportlistexcel: ScanReport[] = [];
  ContractorFirstName: number;
  ContractorId: number;
  ContractorMobile: number;

  fromDate: string; // Add fromDate property
  toDate: string; // Add toDate property
  formval: any = { PageSize: 10, Page: 1, fromdate: '', todate: '', SearchValue: '' }; // Add formval property
  settingslist: null;
  contractorList: Contractor[] = [];


  constructor(private excelService: ExcelService, private toastr: ToastrService, private apiService: ApiService, private modalService: BsModalService) {
    this.pagesUser.Filter = '';
  }
  ngOnInit() {
    //this.getDealerList();
    //this.getDealerContractors();
    this.getContarctorListwithPoints(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
  }



  getContarctorListwithPoints(pageNumber: number, pageSize: number, fromDate: string, toDate: string, searchValue: string) {
    // const formattedFromDate = moment(fromDate).format('YYYY-MM-DD');
    // const formattedToDate = moment(toDate).format('YYYY-MM-DD');
    const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '2022-01-01';
    const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    const requestData = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      searchValue: searchValue ? searchValue : ''
    };
    console.log('requestData', requestData);
    this.apiService.PostApi(requestData, "Report/ContarctorListwithPoints").subscribe((response: any) => {
      debugger
      if (response.ResponseCode == 200) {
        console.log('ContarctorListwithPoints', response.ResponseData);
        // this.dealerlist = response.ResponseData;
        this.totaldata = response.ResponseData.length;
        this.contractorList = response.ResponseData;
        this.totaldata = response.TotalCount;
        if (this.pageSizeOptions.indexOf(this.totaldata) === -1) {
          this.pageSizeOptions = [...this.pageSizeOptions, this.totaldata];
        }

      } else {
        this.toastr.error('No Record Found between dates', 'Error!', {
          timeOut: 2000
        });
      }
    }, error => {
      this.toastr.error('An error occurred while fetching data', 'Error!', {
        timeOut: 2000
      });
    });
  }



  DownloadScanReport() {
    debugger;
    const formattedFromDate = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : '2022-01-01';
    const formattedToDate = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

    let obj = {
      pageNumber: this.formval.Page ? this.formval.Page : 1,
      pageSize: this.totaldata ? this.totaldata : 10,
      searchValues: this.formval.SearchValue ? this.formval.SearchValue : '',
      fromDate: formattedFromDate,
      toDate: formattedToDate
    }
    console.log('parameter obj', obj);

    if (moment(this.formval.fromdate).isAfter(this.formval.todate)) {
      this.toastr.warning('From Date should not be greater than To Date!', 'Warning!', {
        timeOut: 3000
      });
    }
    else {
      this.show = true;
      this.formval.PageSize = this.totaldata[0];
      this.formval.Page = this.formval.pageNumber;
      console.log('obj2', obj);
      this.apiService.PostApi(obj, "Report/ContarctorListwithPoints").subscribe((response: any) => {
        debugger
        if (response.ResponseCode == 200) {
          console.log('dataexcel', response.ResponseData);
          this.scanreportlistexcel = response.ResponseData;
          this.reportExcelPassbook = this.reportExcelPassbook.slice();
          this.scanreportlistexcel.forEach(o => {
            this.reportExcelPassbook.push(
              {
                // ScannedBy: o.Scannedby, 

                Contractor_Code: o.ID,
                Contractor_Name: o.FirstName + ' ' + o.LastName,
                Contractor_Mobile: o.Mobile,
                Contractor_Email: o.Email,
                ScanDate: o.ScanDate,
                TotalEarnedPoints: o.TotalEarnedPoints,
                TotalPendingPoints: o.TotalPendingPoints,
                RedeemedPoints: o.RedeemedPoints,
                CancelPoints: o.CancelPoints,
                AvailablePoints: o.AvailablePoints,

              });
          });
          this.exportAsXLSX(this.reportExcelPassbook);
        }
        else {
          this.toastr.warning('There is no file to download', 'Warning!', {
            timeOut: 1000
          });
        }
      },
        err => {
          this.show = false;
          this.totaldata = 0;
        }
      )
      this.show = false;
    }
    this.formval.Page = 1;
    this.formval.PageSize = 5;
  }

  exportAsXLSX(myreport: any): void {
    //this.excelService.exportAsExcelFile(this.reportExcelPassbook, 'ContractorReport_' + this.formval.ScanStatus + '_' + moment(this.formval.fromdate, "DD-MMM-YYYY").format("DD-MMM-YYYY") + '_to_' + moment(this.formval.todate, "DD-MMM-YYYY").format("DD-MMM-YYYY"));
    if (this.fromDate != null && this.toDate != null) {
      this.excelService.exportAsExcelFile(this.reportExcelPassbook, 'ContractorReport_' + moment(this.fromDate, "DD-MMM-YYYY").format("DD-MMM-YYYY") + '_to_' + moment(this.toDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"));
    }
    else {
      this.excelService.exportAsExcelFile(this.reportExcelPassbook, 'ContractorReport');
    }
    this.formval.PageSize = 5;
  }
  setDates(): any {
    var date = new Date();

    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var currentDay = date.getDate();

    this.formval.fromdate = moment(firstDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    this.formval.todate = moment(currentDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
  }


  getOSearchvalue(user: UserPage): any {
    this.show = true;
    this.pagesUser.UserType = 1;

    this.apiService.PostApi(this.pagesUser, "Setting/GetAllSettings").subscribe((response: any) => {
      debugger;
      if (response.ResponseCode == "200") {
        //  (response)
        this.settingslist = response.ResponseData;
        this.totaldata = response.TotalCount;
        if (this.totaldata < parseInt(this.pagesUser.pageSize)) {
          this.currentPage = 1;
        }
      }
      else {
        this.settingslist = null;
        this.show = false;
      }
    }, err => {
      this.settingslist = null;
      this.show = false;
    });
    this.show = false;
  }


  // pageChanged(event: PageChangedEvent): void {
  //   //  alert(event.page)
  //     const startItem = (event.page - 1) * event.itemsPerPage;
  //     const endItem = event.page * event.itemsPerPage;
  //     this.pagesUser.page=event.page;
  //     this.getOrganisation(this.pagesUser);
  //    //  (this.users)
  //    this.currentPage=event.page+1;
  //   }

  // pageChanged(event: PageChangedEvent): void {
  //   this.formval.Page = event.page;
  //   this.getContarctorListwithPoints(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
  // }
  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.formval.Page = event.page;
    this.getContarctorListwithPoints(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
    this.currentPage = event.page + 1;
  }

  onpagechange() {
    this.formval.Page = 1;
    this.getContarctorListwithPoints(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
  }
  SearchValue(Page: any, PageSize: any, fromDate: string, toDate: string, SearchValue: any) {
    throw new Error('Method not implemented.');
  }

  ShowErrorList(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.modalRef3 = this.modalService.show(template, config);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  alphaOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }
  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    (template);
    this.modalRef = this.modalService.show(template, config);
  }

}
